import React, {useEffect, useState} from "react";


import get from "lodash/get";

import { connect } from "react-redux";
import { bindActionCreators,compose } from "redux";
import {
    loadAccess,
    loadLevel,
    setLoading,
    loadUser,
} from "@app/common/store/action";
import {  withRouter } from "react-router-dom";


import Grid from "@material-ui/core/Grid";
import MFACodeContainer from "../../../components/mfacodecontainer/mfacodecontainer";
import TwoButtonContainer from "../../../components/twobuttoncontainer/twobuttoncontainer";
import {
    MFA_OTP_WRONG_ERR, MFA_VER_SUC_200, MFA_VER_SUC_201
} from "@app/common/constants/constants";


import style from './mfaOTPcodeform.module.css'
import {mfaVerifyTokenService} from "@app/common/services/mfaverifytokenservice";
import {CHANGE_PASSWORD_ROUTE, HOMEPAGE_ROUTE, LOGIN_ROUTE, OPERATOR_ROUTE} from "../../../constants/routeconstants";
import {
    CODE_LENGTH,
    MFA_VERFICATION_TEXT, OPPR_TPYE,
    OTP_EMPTY_ERR,
    OTP_ERROR,
    OTP_Error,
    SUBMIT, USER_TYPE
} from "../../../constants/appconstants";
import {Typography} from "@material-ui/core";


function MfaOTPCodeForm(props){
    const [errorText,setErrorText] = useState("");
    const [otpErrorStatus,setOTPErrorStatus] = useState(false);
    const [secretCode,setSecretCode]  = useState(undefined);
    const [code,setCode]  = useState("");
    const [mfaSession,setMFASession]  = useState("");

    const redirectRoute = (type)=>{

        switch(type){
            case USER_TYPE:
                props.history.push({
                    pathname:HOMEPAGE_ROUTE
                })

                break;
            case OPPR_TPYE:
                let route=OPERATOR_ROUTE()
                window.location.replace(route);
                break;
            default:
                props.history.push({
                    pathname:LOGIN_ROUTE
                })
        }
    }
    const onSubmitHandler = async (e) => {
        e.preventDefault();

        const { actions } = props;
        if(code === "" || code.length < CODE_LENGTH){
            setCode("")
            setOTPErrorStatus(true);
            setErrorText(OTP_EMPTY_ERR)
            return
        }
        actions.setLoading(true);
        try{
            let response = await mfaVerifyTokenService(props.session,code,props.user.userName);
            let serviceResponseHeader = get(response,"serviceResponseHeader");
            let serviceResponseBody = get(response,"serviceResponseBody");
            let statusCode = get(serviceResponseHeader,"statusCode");
            actions.setLoading(false);

            if (statusCode === MFA_VER_SUC_200){
                let type = get(serviceResponseBody,"type")
                 redirectRoute(type)

            } else if(statusCode === MFA_VER_SUC_201)
                props.history.push(CHANGE_PASSWORD_ROUTE)
        }catch(e){
            console.log(e)
            actions.setLoading(false);
            if(e === MFA_OTP_WRONG_ERR)
                setOTPErrorStatus(true);
            setErrorText(e)
            setCode("")
            //  this.setState({ errorText:e,userName: "",password: "", buttonDisabled:true});
        }
    };

    const onCloseRequestHandler = ()=>{
        console.log("closse")
        props.history.push(LOGIN_ROUTE)
    }
    const setMFACodeHandler = (code)=>{
        console.log("code",code)
        setCode(code)
    }

    return (
        <form onSubmit={onSubmitHandler}>
            <Grid container direction={"column"} justify={"center"} alignItems={"center"}>
                <Grid item className={style.mfa_code_form_text}>
                    <Typography>
                        {MFA_VERFICATION_TEXT}
                    </Typography>

                </Grid>
                <Grid item className={style.mfa_code_form_container}>
                    <MFACodeContainer setCodeRequestHandler={setMFACodeHandler} code={code} errorText={errorText} errorStatus={otpErrorStatus}/>
                </Grid>
                <Grid item className={style.mfa_code_form_container}>
                    <TwoButtonContainer title={SUBMIT}
                                        onSubmitRequestHandler={onSubmitHandler}
                                        onCloseRequestHandler={onCloseRequestHandler}/>
                </Grid>
            </Grid>
        </form>

    );
}

const mapStateToProps = (state, ownProps) => ({
    access: state.access,
    session:state.session,
    user:state.user,
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            { loadAccess, loadLevel, setLoading, loadUser },
            dispatch
        ),
    };
}

export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(MfaOTPCodeForm);



